import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI3S_DEMO_1 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: `Meet Danu, Cybersecurity Team Leader at \nGlobe Education. Today, we'll showcase \n<span style="color: #BEE3FF;"> how Infosys AI3S empowers Danu in \noverseeing and securing the platform \nseamlessly.</span> Join us to explore the \nfeatures designed to enhance Danu's\n leadership in AI Model Security.`,
  subtitle: "Infosys AI3S DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(307),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(305),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_05.png",
  rightSideImage: "RESPONSIBLE_AI/AI3S_demo_1.png",
  imageCustomStyle: {
    position: "absolute" as React.CSSProperties["position"],
    bottom: 0,
    right: 0,
  },
};
